import React from 'react';

export const DEFAULT_ATLANTIC_SECTION_ORDER = [
  'companyHeader',
  'solicitud',
  'nosisScores',
  'balanceHeader',
  'indicators',
  'balanceAccordion',
  'nosisDetail',
  'debtCentrals',
] as const;

export type AtlanticSectionKey = (typeof DEFAULT_ATLANTIC_SECTION_ORDER)[number];

type AtlanticChecklightLayoutProps = {
  sectionOrder?: string[] | null;
  sections: Partial<Record<string, React.ReactNode>>;
};

/**
 * Thin orchestrator: renders provided section nodes in `sectionOrder` (or PRD default).
 * Missing / null sections are skipped (no empty wrappers with content).
 */
const AtlanticChecklightLayout: React.FC<AtlanticChecklightLayoutProps> = ({
  sectionOrder,
  sections,
}) => {
  const order =
    Array.isArray(sectionOrder) && sectionOrder.length > 0
      ? sectionOrder
      : [...DEFAULT_ATLANTIC_SECTION_ORDER];

  return (
    <div data-testid="atlantic-checklight-layout">
      {order.map((key) => {
        const node = sections[key];
        if (node == null || node === false) return null;
        return (
          <div key={key} data-section={key} data-testid={`atlantic-section-${key}`}>
            {node}
          </div>
        );
      })}
    </div>
  );
};

export default AtlanticChecklightLayout;
